module.exports = __webpack_public_path__ + "static/media/people-full.bebd4375.png";